import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    importCountryList: () => {
        return HTTP.get('/nationwide_delivery_list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}